import type { ReactNode } from "react";
import { regionOptions, genreOptions, yearOptions } from "@/mocks/films";

interface FilterPanelProps {
  regions: string[];
  years: number[];
  genres: string[];
  onToggleRegion: (value: string) => void;
  onToggleYear: (value: number) => void;
  onToggleGenre: (value: string) => void;
  onReset: () => void;
}

function FilterGroup({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="border-b border-background-200 py-4 last:border-b-0">
      <h3 className="mb-3 font-heading text-sm font-semibold text-foreground-900">{title}</h3>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

function Chip({ active, label, onClick }: { active: boolean; label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-md border px-2.5 py-1 text-xs transition-colors ${
        active
          ? "border-accent-500 bg-accent-500 text-background-50"
          : "border-background-200 bg-background-50 text-foreground-700 hover:border-accent-300"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterPanel({
  regions,
  years,
  genres,
  onToggleRegion,
  onToggleYear,
  onToggleGenre,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-filter-3-line text-lg text-primary-600" />
          筛选条件
        </h2>
        <button type="button" onClick={onReset} className="whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-accent-600">
          重置
        </button>
      </div>

      <FilterGroup title="地区">
        {regionOptions.map((region) => (
          <Chip key={region} label={region} active={regions.includes(region)} onClick={() => onToggleRegion(region)} />
        ))}
      </FilterGroup>

      <FilterGroup title="年份">
        {yearOptions.map((year) => (
          <Chip key={year} label={`${year}`} active={years.includes(year)} onClick={() => onToggleYear(year)} />
        ))}
      </FilterGroup>

      <FilterGroup title="类型">
        {genreOptions.map((genre) => (
          <Chip key={genre} label={genre} active={genres.includes(genre)} onClick={() => onToggleGenre(genre)} />
        ))}
      </FilterGroup>
    </div>
  );
}